//"use client";

import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import { getPreloadedData, PreloadedScript } from "../../utils/preloadedData";
import "./../OurTeam/OurTeam.css";

function OurTeam() {
  // Seeded from the prerendered snapshot so the first client render matches the static HTML.
  const [teamMembers, setTeamMembers] = useState(() => getPreloadedData("__PRELOADED_ABOUT_TEAM__") || []);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(() => getPreloadedData("__PRELOADED_ABOUT_TEAM__") === null);
  const [error, setError] = useState(null);

  const membersPerPage = 6;

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await axiosInstance.get("/api/team-members");
        setTeamMembers(response.data || []);
      } catch (err) {
        setError("Failed to fetch team members");
        console.error("Error fetching team members:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);

  if (loading) {
    return (
      <div className="main_div_ourteam">
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main_div_ourteam">
        <p>{error}</p>
      </div>
    );
  }

  // Use only regular members (excluding the first 3)
  const regularMembers = teamMembers.slice(2);

  // Calculate pagination for regular members
  const totalPages = Math.ceil(regularMembers.length / membersPerPage);
  const startIndex = (currentPage - 1) * membersPerPage;
  const currentRegularMembers = regularMembers.slice(
    startIndex,
    startIndex + membersPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="main_div_ourteam">
      <PreloadedScript id="__PRELOADED_ABOUT_TEAM__" data={teamMembers} />
      <p className="our_team_heading">OUR TEAM</p>
      <p className="our_team_heading_meet">Meet the Team</p>
      <div className="d-flex justify-content-center">
        <div className="hr_line_black" />
      </div>

      <div className="row m-0 p-0">
        <div className="col-lg-1 col-md-1 col-sm-12 col-12"></div>
        <div className="col-lg-10 col-md-10 col-sm-12 col-12">
          {/* Regular Team Members (Rest - Large with Pagination) */}
          {regularMembers.length > 0 && (
            <>
              <div className="row regular-members-section">
                {currentRegularMembers.map((member, index) => (
                  <div
                    key={member.id}
                    className="col-lg-4 col-md-4 col-sm-6 col-12 p-2"
                  >
                    <img
                      className="team_member_pic_b"
                      src={`${process.env.REACT_APP_BASE_URL}/images/${member.photo}`}
                      alt={member.name}
                      width="286"
                      height="251"
                      loading="lazy"
                    />
                    <div className="description_team_member_b">
                      <p className="name_member_b">{member.name}</p>
                      <p className="desp_member_b">{member.role}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination-container">
                  <div className="d-flex justify-content-center">
                    {Array.from({ length: totalPages }, (_, index) => (
                      <button
                        key={index + 1}
                        className={`pagination-btn ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="col-lg-1 col-md-1 col-sm-12 col-12"></div>
      </div>
    </div>
  );
}

export default OurTeam;